module.exports = __webpack_public_path__ + "static/media/kodfit.7d9cc76d.png";